import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RulerIcon } from '@cdl/heartbeat-react';
import { setActiveTool } from '../../tool/actions/tool.actions';
import { isToolActiveSelector } from '../../tool/selectors/tool.selectors';
import { Tool } from '../../tool/utils/tool.utils';
import * as analyticsInfoActions from '../../analytics/actions/analytics-info.actions';
import { trackUseRuler } from '../../analytics/thunks/track-use-ruler.thunk';
import { trackStopRuler } from '../../analytics/thunks/track-stop-ruler.thunk';
import { ToolButton } from '../../../features/tool/components/ToolButton';

export const Ruler2dTool: React.FC = () => {
  const dispatch = useDispatch();
  const isRuler2dActive = useSelector(isToolActiveSelector(Tool.ruler2d));
  const activateRuler2d = () => {
    dispatch(
      analyticsInfoActions.setRulerInteraction({ interaction: 'click' }),
    );
    dispatch(
      isRuler2dActive ? trackStopRuler('click') : trackUseRuler('click'),
    );
    dispatch(
      setActiveTool({
        tool: isRuler2dActive ? null : Tool.ruler2d,
        meta: { history: false },
      }),
    );
  };
  return (
    <ToolButton
      label='2D Ruler'
      onClick={activateRuler2d}
      isActive={isRuler2dActive}
      aria-label='2D Ruler'
      icon={<RulerIcon />}
    />
  );
};
